import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { MsalProvider } from '@azure/msal-react';
import { msalInstance } from '@lib/msal';
import { queryClient } from '@lib/queryClient';
import App from './App';
import './index.css';

// Initialize MSAL and handle redirect response
msalInstance.initialize().then(() => {
  // Handle the redirect response from Microsoft login
  msalInstance.handleRedirectPromise()
    .then((response) => {
      if (response) {
        console.log('Login successful:', response.account?.username);
      }
    })
    .catch((error) => {
      console.error('Login redirect error:', error);
    })
    .finally(() => {
      // Render the app after handling any redirect
      ReactDOM.createRoot(document.getElementById('root')!).render(
        <React.StrictMode>
          <MsalProvider instance={msalInstance}>
            <QueryClientProvider client={queryClient}>
              <BrowserRouter>
                <App />
              </BrowserRouter>
            </QueryClientProvider>
          </MsalProvider>
        </React.StrictMode>
      );
    });
});
